/*
  TODO: Lighthouse scores are dropping due to authentication
  features. Disabling these features for now
*/
import axios from 'axios';
import React, { ReactNode, useEffect, useState } from 'react';
import { LocationProps } from '@models/navigation';
import { PageContextData } from '@models/pages';
import Footer from './footer';
import Header from './header';
// 6/19/23 - SR - will re-enable below when ready to convert to custom pageview event
import { pushToCustomDataLayer } from '../../.services/analytics.services';
import { GlobalContextProvider, LiveData } from '../GlobalContext/index';
import SmsRemindersModal from '../Modals/SmsRemindersModal';
import SocialShareModal from '../Modals/SocialShareModal';
// import { PrivateRoute } from '../auth';
// import { AuthProvider } from '../auth/AuthContext';

type Props = {
  children: ReactNode;
  location: LocationProps;
  lang: string;
  locales: { lang: string; slug: string }[] | null;
  page: PageContextData;
  isPrivate?: boolean;
};

// function PrivateWrapper({ isPrivate, children }: { isPrivate: boolean, children: any }) {
//   return isPrivate ? (<PrivateRoute path="/Login">{children}</PrivateRoute>) : children;
// }

export default function Layout({
  children,
  location,
  page,
  lang = 'en',
  locales,
  // eslint-disable-next-line no-unused-vars
  isPrivate,
}: Props) {
  const [liveItems, setLiveItems] = useState<LiveData[]>([]);
  const [extendedPushDown, setExtendedPushDown] = useState<Boolean>(false);
  const [showModal, setShowModal] = useState('');

  // 6/19/23 - SR - will re-enable below when ready to convert to custom pageview event
  useEffect(() => {
    if (typeof window !== 'undefined') {
      pushToCustomDataLayer(location, lang, locales);
    }
  }, []);

  useEffect(() => {
    const getLiveChatEntries = async () => {
      const { data: liveEntriesResp } = await axios.get('/api/chat/get-live-data');
      if (liveEntriesResp.liveVideos?.length === 0) {
        return;
      }
      setLiveItems(liveEntriesResp.liveVideos);
    };
    getLiveChatEntries();
  }, []);

  return (
    // <AuthProvider>
    <GlobalContextProvider
      value={{
        liveItems, extendedPushDown, setExtendedPushDown, showModal, setShowModal,
      }}
    >
      <div className="grid grid-rows-[auto_1fr_auto] min-h-screen relative ">
        <Header
          location={location}
          lang={lang}
          locales={locales}
        />
        <div className="relative w-full overflow-auto bg-darkGrey">
          {/* <PrivateWrapper isPrivate={isPrivate!}> */}
          <div className="mx-auto bg-darkGrey pb-[20px] lg:pb-[40px]">
            {children}
          </div>
          {/* </PrivateWrapper> */}
        </div>
        <SmsRemindersModal />
        <SocialShareModal
          lang={lang}
          href={location.href}
          stringTranslations={page.stringTranslations}
        />
        <Footer lang={lang} />
      </div>
    </GlobalContextProvider>
    // </AuthProvider>
  );
}

Layout.defaultProps = {
  isPrivate: false,
};
